// extracted by mini-css-extract-plugin
export default {"container":"container__pHEgg","docContainer":"docContainer__sulNJ","heading":"heading__tEKqj","subheading":"subheading__RaF6j"};